/**
 * FF Product UX JS (No-snippet) - FULL FILE REPLACEMENT (Improved)
 * - Modal (size guide)
 * - Sticky ATC visibility
 * - Sticky ATC now triggers real add-to-cart (no price appended to button text)
 * - Gallery thumbs swap (no theme dependencies)
 * - Variant selection (dropdowns + size chips)
 * - Updates: variant id, URL ?variant=, price/compare, sticky price/compare, ATC availability
 * - Fix: Restores configured ATC text when variant becomes available again
 * - Optional: Shows selected size in sticky if Liquid includes [data-ffp-sticky-size]
 * - NEW: No preselected size on load + validation message if ATC clicked without size
 */

(() => {
  const root = document.querySelector('.ffp');
  if (!root) return;

  // -----------------------
  // Modal (sizeguide)
  // -----------------------
  const openBtns = root.querySelectorAll('[data-ffp-open]');
  const closeSelectors = '[data-ffp-close]';

  function openModal(name) {
    const modal = root.querySelector(`[data-ffp-modal="${name}"]`);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  openBtns.forEach((btn) => {
    btn.addEventListener('click', () => openModal(btn.getAttribute('data-ffp-open')));
  });

  root.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    if (target.matches(closeSelectors)) {
      const modal = target.closest('.ffp__modal');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openModalEl = root.querySelector('.ffp__modal[aria-hidden="false"]');
    if (openModalEl) closeModal(openModalEl);
  });

  // -----------------------
  // Sticky ATC visibility
  // -----------------------
  const sticky = root.querySelector('[data-ffp-sticky]');
  const buyBox = document.querySelector('#ffp-buy');

  if (sticky && buyBox) {
    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      },
      { threshold: 0.15 }
    );
    io.observe(buyBox);
  }

  // -----------------------
  // Gallery thumbs (no theme dependencies)
  // -----------------------
  const mediaJsonEl = root.querySelector('[data-ffp-media-json]');
  const mainEl = root.querySelector('[data-ffp-gallery-main]');
  const thumbs = root.querySelectorAll('[data-ffp-thumb]');

  if (mediaJsonEl && mainEl && thumbs.length) {
    let mediaList = [];
    try {
      mediaList = JSON.parse(mediaJsonEl.textContent);
    } catch (e) {
      mediaList = [];
    }

    const byId = new Map(mediaList.map((m) => [String(m.id), m.html]));
    const ids = mediaList.map((m) => String(m.id));

    const getActiveIndex = () => {
      const activeBtn = root.querySelector('.ffp__thumb.is-active');
      if (!activeBtn) return 0;
      const id = activeBtn.getAttribute('data-ffp-media-id');
      const idx = ids.indexOf(String(id));
      return idx >= 0 ? idx : 0;
    };

    const setActiveByIndex = (idx) => {
      if (!ids.length) return;

      if (idx < 0) idx = ids.length - 1;
      if (idx >= ids.length) idx = 0;

      const id = ids[idx];
      const html = byId.get(String(id));
      if (html) mainEl.innerHTML = `<div class="ffp__media-frame">${html}</div>`;

      thumbs.forEach((t) => t.classList.remove('is-active'));
      const btn = root.querySelector(`[data-ffp-thumb][data-ffp-media-id="${id}"]`);
      if (btn) {
        btn.classList.add('is-active');
        try {
          btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch (e) {}
      }
    };

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-ffp-media-id');
        const idx = ids.indexOf(String(id));
        setActiveByIndex(idx >= 0 ? idx : 0);
      });
    });

    let touchStartX = 0;
    let touchStartY = 0;
    const SWIPE_THRESHOLD = 40;

    mainEl.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    mainEl.addEventListener(
      'touchend',
      (e) => {
        if (!e.changedTouches || !e.changedTouches[0]) return;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;

        const dx = endX - touchStartX;
        const dy = endY - touchStartY;

        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (Math.abs(dx) < Math.abs(dy)) return;

        const current = getActiveIndex();
        if (dx < 0) {
          setActiveByIndex(current + 1);
        } else {
          setActiveByIndex(current - 1);
        }
      },
      { passive: true }
    );

    setActiveByIndex(getActiveIndex());
  }

  // -----------------------
  // Variant selector (dropdowns + size chips)
  // -----------------------
  const variantsWrap = root.querySelector('[data-ffp-variants]');
  const formEl = root.querySelector('form.ffp__form');
  const atcBtn = root.querySelector('[data-ffp-atc]');

  const DEFAULT_ATC_TEXT = atcBtn ? atcBtn.textContent.trim() : 'Læg i kurv';

  const stickyBtn = sticky ? sticky.querySelector('.ffp__sticky-btn') : null;
  const stickySizeEl = root.querySelector('[data-ffp-sticky-size]');

  const getVariantErrorEl = () => root.querySelector('[data-ffp-variant-error]');

  const hideVariantError = () => {
    const el = getVariantErrorEl();
    if (el) {
      el.style.display = 'none';
      el.textContent = '';
    }
  };

  const showVariantError = (message = 'Vælg din størrelse før du lægger i kurv') => {
    const el = getVariantErrorEl();
    if (!el) return;
    el.textContent = message;
    el.style.display = 'block';
  };

  const scrollToSize = () => {
    const sizeWrap = root.querySelector('[data-ffp-size-chips]');
    if (!sizeWrap) return;
    sizeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  if (stickyBtn) {
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!formEl || !atcBtn) {
        buyBox?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      if (atcBtn.disabled) {
        buyBox?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      try {
        if (typeof formEl.requestSubmit === 'function') {
          formEl.requestSubmit(atcBtn);
        } else {
          atcBtn.click();
        }
      } catch (err) {
        atcBtn.click();
      }
    });
  }

  // -----------------------
  // Normal product form AJAX add-to-cart
  // -----------------------
  async function ffpMainAddToCart(form) {
    const formData = new FormData(form);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: formData
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      const msg =
        data?.description ||
        data?.message ||
        (data?.errors ? JSON.stringify(data.errors) : null) ||
        'Kunne ikke tilføje';
      throw new Error(msg);
    }

    return data;
  }

  async function ffpMainFetchSections() {
    const url = `/?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
    const res = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!res.ok) throw new Error('Section refresh failed');

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      throw new Error('Sections response not JSON');
    }
  }

  function ffpMainRenderSections(sectionsMap) {
    if (sectionsMap && sectionsMap['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsMap['cart-drawer'], 'text/html');

      const newRoot = doc.querySelector('cart-drawer') || doc.querySelector('#CartDrawer');
      const currentRoot = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');

      if (newRoot && currentRoot) {
        currentRoot.replaceWith(newRoot);
      }
    }

    if (sectionsMap && sectionsMap['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsMap['cart-icon-bubble'], 'text/html');

      const newBubbleSection =
        doc.querySelector('#shopify-section-cart-icon-bubble') ||
        doc.querySelector('#cart-icon-bubble')?.parentElement;

      const currentBubbleSection = document.querySelector('#shopify-section-cart-icon-bubble');

      if (newBubbleSection && currentBubbleSection) {
        currentBubbleSection.innerHTML = newBubbleSection.innerHTML;
      }
    }

    requestAnimationFrame(() => {
      const drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');

      if (!drawer) return;

      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active');
        drawer.removeAttribute('aria-hidden');

        const overlay = document.querySelector('.drawer__overlay');
        if (overlay) overlay.classList.add('is-visible');

        document.documentElement.classList.add('overflow-hidden');
      }
    });
  }

  // If no variant UI, normal ATC still works
  if (formEl && atcBtn) {
    formEl.addEventListener('submit', async (e) => {
      e.preventDefault();

      const sizeSelectEl = root.querySelector('[data-ffp-size-chips] select[data-ffp-option-index]');
      const variantIdInputCheck = root.querySelector('[data-ffp-variant-id]');

      if (sizeSelectEl && !sizeSelectEl.value) {
        showVariantError();
        scrollToSize();
        return;
      }

      if (variantIdInputCheck && !variantIdInputCheck.value) {
        showVariantError();
        scrollToSize();
        return;
      }

      hideVariantError();

      if (atcBtn.disabled) return;

      const originalText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Tilføjer...';

      try {
        await ffpMainAddToCart(formEl);

        const cart = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }).then((r) => r.json());

        ffpUpdateHeaderCartBadge(cart.item_count);

        const sectionsMap = await ffpMainFetchSections();
        ffpMainRenderSections(sectionsMap);

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        atcBtn.textContent = 'Tilføjet ✓';

        setTimeout(() => {
          atcBtn.disabled = false;
          atcBtn.textContent = DEFAULT_ATC_TEXT;
        }, 1200);
      } catch (err) {
        console.error('[FF Main ATC] Add failed:', err);
        atcBtn.textContent = err && err.message ? err.message : 'Prøv igen';

        setTimeout(() => {
          atcBtn.disabled = false;
          atcBtn.textContent = DEFAULT_ATC_TEXT;
        }, 1500);
      }
    });
  }

  if (!variantsWrap) return;

  const jsonEl = variantsWrap.querySelector('[data-ffp-variant-json]');
  if (!jsonEl) return;

  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.warn('FFP: Could not parse variants JSON');
    return;
  }

  const optionSelects = variantsWrap.querySelectorAll('select[data-ffp-option-index]');
  const chips = variantsWrap.querySelectorAll('[data-ffp-chip]');

  const variantIdInput = root.querySelector('[data-ffp-variant-id]');
  const priceEl = root.querySelector('[data-ffp-price]');
  const compareEl = root.querySelector('[data-ffp-compare]');
  const stickyPrice = root.querySelector('[data-ffp-sticky-price]');
  const stickyCompare = root.querySelector('[data-ffp-sticky-compare]');
  const sizeSelect = root.querySelector('[data-ffp-size-chips] select[data-ffp-option-index]');

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    try {
      return new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'DKK'
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2);
    }
  };

  const getSelectedOptions = () => {
    const opts = [];
    optionSelects.forEach((sel) => {
      const idx = Number(sel.dataset.ffpOptionIndex);
      opts[idx] = sel.value;
    });
    return opts;
  };

  const findMatchingVariant = (selectedOptions) => {
    return variants.find((v) => {
      if (!Array.isArray(v.options)) return false;
      if (v.options.length !== selectedOptions.length) return false;
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });
  };

  const updateUrl = (variantId) => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  };

  const setATCState = (available) => {
    if (!atcBtn) return;
    atcBtn.disabled = !available;

    if (available) {
      atcBtn.textContent = DEFAULT_ATC_TEXT;
    } else {
      atcBtn.textContent = 'Udsolgt';
    }
  };

  const getSelectedSizeValue = () => {
    const activeChip = variantsWrap.querySelector('[data-ffp-size-chips] .ffp__chip.is-active');
    if (activeChip) return activeChip.textContent.trim();

    return sizeSelect ? sizeSelect.value : '';
  };

  const updateStickySize = () => {
    if (!stickySizeEl) return;
    const sizeVal = getSelectedSizeValue();
    stickySizeEl.textContent = sizeVal ? ` · Str. ${sizeVal}` : '';
  };

  function ffpUpdateHeaderCartBadge(count) {
    const n = Number(count || 0);

    const badgeSelectors = [
      '#cart-icon-bubble .cart-count-bubble span',
      '#cart-icon-bubble .cart-count-bubble',
      '.header__icon--cart .cart-count-bubble span',
      '.header__icon--cart .cart-count-bubble',
      '[data-cart-count]',
      '.cart-count-bubble span',
      '.cart-count-bubble'
    ];

    let updated = false;

    badgeSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el) return;

        if (n > 0) {
          el.textContent = String(n);

          const bubble = el.classList.contains('cart-count-bubble') ? el : el.closest('.cart-count-bubble');

          if (bubble) {
            bubble.hidden = false;
            bubble.style.display = '';
            bubble.removeAttribute('hidden');
            bubble.setAttribute('aria-hidden', 'false');
          }
        } else {
          const bubble = el.classList.contains('cart-count-bubble') ? el : el.closest('.cart-count-bubble');

          if (bubble) {
            bubble.hidden = true;
            bubble.style.display = 'none';
          }
        }

        updated = true;
      });
    });

    if (!updated && n > 0) {
      const cartIcon =
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('a[href="/cart"]');

      if (cartIcon && !cartIcon.querySelector('.cart-count-bubble')) {
        const bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = `<span aria-hidden="true">${n}</span>`;
        cartIcon.appendChild(bubble);
      }
    }
  }

  const applyVariant = (variant) => {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    setATCState(Boolean(variant.available));

    const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (hasCompare) {
        compareEl.style.display = '';
        compareEl.textContent = formatMoney(variant.compare_at_price);
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (stickyCompare) {
      if (hasCompare) {
        stickyCompare.style.display = '';
        stickyCompare.textContent = formatMoney(variant.compare_at_price);
      } else {
        stickyCompare.style.display = 'none';
      }
    }

    updateStickySize();
    updateUrl(variant.id);
  };

  const syncChipsUI = (idx, val) => {
    chips.forEach((c) => {
      if (Number(c.dataset.ffpOptionIndex) !== idx) return;

      const active = c.dataset.ffpOptionValue === val;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
      c.style.background = active ? '#111' : '#fff';
      c.style.color = active ? '#fff' : '#111';
    });
  };

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const idx = Number(chip.dataset.ffpOptionIndex);
      const val = chip.dataset.ffpOptionValue;

      const sel = variantsWrap.querySelector(`select[data-ffp-option-index="${idx}"]`);
      if (sel) sel.value = val;

      syncChipsUI(idx, val);
      hideVariantError();
      updateStickySize();

      if (sel) sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  optionSelects.forEach((sel) => {
    sel.addEventListener('change', () => {
      const selected = getSelectedOptions();
      const match = findMatchingVariant(selected);

      if (match) {
        applyVariant(match);
      } else if (variantIdInput) {
        variantIdInput.value = '';
      }

      const idx = Number(sel.dataset.ffpOptionIndex);
      if (chips.length) syncChipsUI(idx, sel.value);

      hideVariantError();
      updateStickySize();
    });
  });

  // Initial state: no preselected size => no active variant id
  const initialSelected = getSelectedOptions();
  const hasChosenSize = sizeSelect ? Boolean(sizeSelect.value) : true;
  const initialMatch = findMatchingVariant(initialSelected);

  if (hasChosenSize && initialMatch) {
    applyVariant(initialMatch);
  } else {
    if (variantIdInput) variantIdInput.value = '';
    hideVariantError();
    updateStickySize();
  }

  if (chips.length) {
    optionSelects.forEach((sel) => {
      const idx = Number(sel.dataset.ffpOptionIndex);
      syncChipsUI(idx, sel.value);
    });
  }

  updateStickySize();

  // -----------------------
  // Matching products cross-sell
  // -----------------------
  const matchWrap = root.querySelector('[data-ffp-match]');

  function ffpGetMainSelectedSize() {
    const activeChip = root.querySelector('[data-ffp-size-chips] .ffp__chip.is-active');
    if (activeChip) return activeChip.textContent.trim();

    const hiddenSizeSelect = root.querySelector('[data-ffp-size-chips] select[data-ffp-option-index]');
    if (hiddenSizeSelect) return hiddenSizeSelect.value;

    return '';
  }

  function ffpUpdateHeaderCartBadge(count) {
    const n = Number(count || 0);

    const badgeSelectors = [
      '#cart-icon-bubble .cart-count-bubble span',
      '#cart-icon-bubble .cart-count-bubble',
      '.header__icon--cart .cart-count-bubble span',
      '.header__icon--cart .cart-count-bubble',
      '[data-cart-count]',
      '.cart-count-bubble span',
      '.cart-count-bubble'
    ];

    let updated = false;

    badgeSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el) return;

        if (n > 0) {
          el.textContent = String(n);

          const bubble = el.classList.contains('cart-count-bubble') ? el : el.closest('.cart-count-bubble');

          if (bubble) {
            bubble.hidden = false;
            bubble.style.display = '';
            bubble.removeAttribute('hidden');
            bubble.setAttribute('aria-hidden', 'false');
          }
        } else {
          const bubble = el.classList.contains('cart-count-bubble') ? el : el.closest('.cart-count-bubble');

          if (bubble) {
            bubble.hidden = true;
            bubble.style.display = 'none';
          }
        }

        updated = true;
      });
    });

    if (!updated && n > 0) {
      const cartIcon =
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('a[href="/cart"]');

      if (cartIcon && !cartIcon.querySelector('.cart-count-bubble')) {
        const bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = `<span aria-hidden="true">${n}</span>`;
        cartIcon.appendChild(bubble);
      }
    }
  }

  async function ffpMatchAddToCart(variantId) {
    const id = parseInt(String(variantId), 10);
    if (!id) throw new Error('Ugyldig variant');

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id, quantity: 1 })
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      const msg =
        data?.description ||
        data?.message ||
        (data?.errors ? JSON.stringify(data.errors) : null) ||
        'Kunne ikke tilføje';
      throw new Error(msg);
    }

    return data;
  }

  async function ffpMatchFetchSections() {
    const url = `/?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
    const res = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!res.ok) throw new Error('Section refresh failed');

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      throw new Error('Sections response not JSON');
    }
  }

  function ffpMatchRenderSections(sectionsMap) {
    if (sectionsMap && sectionsMap['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsMap['cart-drawer'], 'text/html');

      const newRoot = doc.querySelector('cart-drawer') || doc.querySelector('#CartDrawer');
      const currentRoot = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');

      if (newRoot && currentRoot) {
        currentRoot.replaceWith(newRoot);
      }
    }

    if (sectionsMap && sectionsMap['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsMap['cart-icon-bubble'], 'text/html');

      const newBubbleSection =
        doc.querySelector('#shopify-section-cart-icon-bubble') ||
        doc.querySelector('#cart-icon-bubble')?.parentElement;

      const currentBubbleSection = document.querySelector('#shopify-section-cart-icon-bubble');

      if (newBubbleSection && currentBubbleSection) {
        currentBubbleSection.innerHTML = newBubbleSection.innerHTML;
      }
    }

    requestAnimationFrame(() => {
      const drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');

      if (!drawer) return;

      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active');
        drawer.removeAttribute('aria-hidden');

        const overlay = document.querySelector('.drawer__overlay');
        if (overlay) overlay.classList.add('is-visible');

        document.documentElement.classList.add('overflow-hidden');
      }
    });
  }

  function syncMatchCardsToMainSize() {
    if (!matchWrap) return;

    const mainSize = ffpGetMainSelectedSize();
    if (!mainSize) return;

    const cards = matchWrap.querySelectorAll('[data-ffp-match-card]');
    cards.forEach((card) => {
      const matchingChip = Array.from(card.querySelectorAll('[data-ffp-match-size]')).find(
        (btn) => (btn.dataset.size || '').trim() === mainSize
      );

      if (!matchingChip) return;

      card.querySelectorAll('[data-ffp-match-size]').forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });

      matchingChip.classList.add('is-active');
      matchingChip.setAttribute('aria-pressed', 'true');

      const hiddenVariant = card.querySelector('.ffp__match-selected-variant');
      const hiddenSize = card.querySelector('.ffp__match-selected-size');
      const addBtn = card.querySelector('[data-ffp-match-add]');

      if (hiddenVariant) hiddenVariant.value = matchingChip.dataset.variantId || '';
      if (hiddenSize) hiddenSize.value = matchingChip.dataset.size || '';
      if (addBtn) addBtn.disabled = !hiddenVariant?.value;
    });
  }

  if (matchWrap) {
    syncMatchCardsToMainSize();

    document.addEventListener('click', async function (e) {
      const sizeBtn = e.target.closest('[data-ffp-match-size]');
      if (sizeBtn) {
        const card = sizeBtn.closest('[data-ffp-match-card]');
        if (!card) return;

        card.querySelectorAll('[data-ffp-match-size]').forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });

        sizeBtn.classList.add('is-active');
        sizeBtn.setAttribute('aria-pressed', 'true');

        const hiddenVariant = card.querySelector('.ffp__match-selected-variant');
        const hiddenSize = card.querySelector('.ffp__match-selected-size');
        const addBtn = card.querySelector('[data-ffp-match-add]');

        if (hiddenVariant) hiddenVariant.value = sizeBtn.dataset.variantId || '';
        if (hiddenSize) hiddenSize.value = sizeBtn.dataset.size || '';
        if (addBtn) addBtn.disabled = !(hiddenVariant && hiddenVariant.value);

        return;
      }

      const addBtn = e.target.closest('[data-ffp-match-add]');
      if (!addBtn) return;

      const card = addBtn.closest('[data-ffp-match-card]');
      if (!card) return;

      const variantInput = card.querySelector('.ffp__match-selected-variant');
      const variantId = variantInput ? variantInput.value : '';

      if (!variantId) return;

      const originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Tilføjer...';

      try {
        await ffpMatchAddToCart(variantId);

        const cart = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }).then((r) => r.json());

        ffpUpdateHeaderCartBadge(cart.item_count);

        const sectionsMap = await ffpMatchFetchSections();
        ffpMatchRenderSections(sectionsMap);

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        addBtn.classList.add('is-added');
        addBtn.textContent = 'Tilføjet ✓';

        setTimeout(() => {
          addBtn.classList.remove('is-added');
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1400);
      } catch (err) {
        console.error('[FF Product Cross-sell] Add failed:', err);
        addBtn.textContent = err && err.message ? err.message : 'Prøv igen';

        setTimeout(() => {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1400);
      }
    });

    optionSelects.forEach((sel) => {
      sel.addEventListener('change', () => {
        syncMatchCardsToMainSize();
      });
    });
  }
})();

document.addEventListener('click', (e) => {
  const minus = e.target.closest('[data-ffp-qty-minus]');
  const plus = e.target.closest('[data-ffp-qty-plus]');
  if (!minus && !plus) return;

  const wrap = e.target.closest('.ffp__qty');
  const input = wrap?.querySelector('.ffp__qty-input');
  if (!input) return;

  const current = parseInt(input.value || '1', 10);
  const next = plus ? current + 1 : Math.max(1, current - 1);
  input.value = String(next);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});